<template>
  <div class="bg">
    <div
      class="px-5 pt-8 pb-8 mx-4 mt-8 mb-12 rounded lg:rounded-none lg:mb-0 lg:mx-0 lg:mt-0 bg-i4m-grey-light lg:h-screen lg:w-2/4 box-grigio"
    >
      <h1 class="mb-4 text-2xl font-bold lg:text-3xl">
        {{ $t('widget.title') }}
      </h1>
      <h2 class="mb-12 text-lg opacity-75 text-md">
        {{ $t('widget.subtitle') }}
      </h2>

      <!-- <a-spin class="pl-5" v-if="$store.state.gettingOrder" /> -->

      <div
        v-if="hasOngoingOrderWithItems"
        class="flex items-center justify-start px-8 py-5 mb-8 bg-white border-2 rounded-md border-i4m-orange"
      >
        <div class="flex items-center justify-center p-4 mr-6 bg-orange-200 rounded-full">
          <a-icon type="shopping-cart" :style="{ fontSize: '2rem', color: '#ed8936' }" />
        </div>

        <div class="text-lg font-semibold">
          Sembra tu abbia un ordine in corso.
          <br />
          <a class="text-i4m-orange" @click="$router.push({ name: $store.getters.currentStep })">
            Clicca qui per riprendere da dove eri rimasto.
          </a>
        </div>
      </div>

      <div v-if="hasOngoingOrderWithItems" class="mb-4">
        Oppure riparti dall'inzio:
      </div>

      <add-item-widget :stopAfterStep="1" :onAddedInstrument="startWizard" :hideCancel="true" />
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'home',
  computed: {
    orderToReset() {
      return this.$store.state.order ? true : false;
    },

    hasOngoingOrderWithItems() {
      return this.$store.state.order && this.$store.state.order.order_items.length > 0;
    }
  },
  methods: {
    async startWizard(itemId) {
      const hide = this.$message.loading('Aggiugendo al carrello..', 0);
      await this.addInstrument(itemId);
      await this.$store.dispatch('getOrder');
      hide();
      this.$router.push({ name: 'instruments' });
    },

    async addInstrument(itemId) {
      // se aggiungo un nuovo strumento faccio il reset dell'ordine attivo
      this.$store.commit('setActiveOrder', null);
      if (this.orderToReset) {
        await api.resetOrder();
      }

      try {
        await api.addOrderItem(itemId);
      } catch (e) {
        this.$notification.error({
          message: "C'è stato un errore nell'inserimento dello strumento nel carrello. Contattaci!",
          duration: 300
        });
        return;
      }
    }
  }
};
</script>

<style lang="scss">
@import '@/variables.scss';
.bg {
  @media #{$lg} {
    min-height: 1000px !important;
  }
}
.box-grigio {
  min-height: inherit !important;
}
</style>
